"use client";
import React from "react";

type Optional<T> = T | null;
interface ValidationProps {
  /**
   * React hook form property
   */
  register?: any; // TODO type
  /**
   * React hook form property
   */
  control?: any; // TODO type
  /**
   * React hook form property
   */
  errors?: any; // TODO type
  /**
   * React hook form property
   */
  customHelperText?: any; // TODO type
}

/**
 * @deprecated Deprecated. Use resolver?: Resolver<T>; in GenericForm.tsx instead.
 */
export const ValidationContext =
  React.createContext<Optional<ValidationProps>>(null);
